import React, { PureComponent, Fragment } from 'react'
import {
    Typography,
    Switch,
} from '@material-ui/core'
import { CustomTooltip } from 'shared/mui-styles';
import { Help } from '@material-ui/icons';
import BarChartForLayers from 'bundles/Dashboard/components/BarChartForLayers'
import TabsForTransitLayer from 'bundles/Dashboard/components/TabsForTransitLayer'
// import { Button, ButtonGroup } from '@material-ui/core'

const classes = {
    h7: {
        fontSize: '1.10rem',
        fontWeight: '400',
    },
}

class SwitchPanel extends PureComponent {
    render() {
        const { 
            data, 
            title, 
            handleSwitch,
            handleLayerFilter,
            transportationDataFilterRange,
            foodDesertDataFilterRange,
            lossAffordableHousingDataFilterRange,
            risingRentDataFilterRange,
            raceDataFilterRange,
            incomeDataFilterRange,
            transitDataFilterChoice,
            setChoiceForTransitLayer
         } = this.props;

        // console.log(data)

        const switches = data.map((obj, i) => (
            <div key={i} >
                <div className="row">
                <div className="col">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography variant="body2">{obj.label}</Typography>
                            <CustomTooltip
                                title={obj.tooltip}
                                placement="right"
                            >
                                <Help fontSize="small" style={{ marginLeft: 7 }} color="secondary" />
                            </CustomTooltip>
                        </div>
                       
                        <Switch
                            checked={obj.stateVariable}
                            onChange={handleSwitch}
                            value={obj.value}
                            color="primary"
                        />
                    
                      
                    </div>
                </div>
                </div>
                {obj.stateVariable?
                    <div className="row">
                    
                        <div className="col">
                        
                        {obj.displayByBarchart ? <BarChartForLayers
                            source={obj.geoData}
                            id= {obj.value}
                            dataFieldName = {obj.dataFieldName}
                            transportationDataFilterRange={transportationDataFilterRange}
                            foodDesertDataFilterRange={foodDesertDataFilterRange}
                            lossAffordableHousingDataFilterRange={lossAffordableHousingDataFilterRange}
                            risingRentDataFilterRange={risingRentDataFilterRange}
                            raceDataFilterRange={raceDataFilterRange}
                            incomeDataFilterRange={incomeDataFilterRange}
                            handleLayerFilter = {handleLayerFilter}
                            value={obj.layerData}
                        />:<TabsForTransitLayer
              
                        transitDataFilterChoice={transitDataFilterChoice}
                        setChoiceForTransitLayer={setChoiceForTransitLayer}
                 
                        />}
                        </div>
                        
                    </div>
                    :null
                }
               
            </div>
           
        ))

        return (
            <Fragment>
                <div className="row">
                    <div className="col">
                        <Typography variant="h6" style={classes.h7}>{title}</Typography>
                    </div>
                </div>
               {switches}
               
            </Fragment>
        )
    }
}

export default SwitchPanel;